import "./Management.scss";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { HiSearch } from "react-icons/hi";
import { FaPen } from "react-icons/fa";
import { CgClose } from "react-icons/cg";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import { connect } from "react-redux";
import { updateMenu } from "Redux/Actions/menuActions";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import { fr } from "date-fns/locale";
import "../Evenements/EvenementsManagement/EvenementsManagement.scss";
import { Link } from "react-router-dom";
import { formatDateDatabase } from "Services/functions";
import MassActions from "Components/Offres/GestionDepotOffre/MassActions/MassActions";
import { useTranslation } from "react-i18next";

registerLocale("fr", fr);
const Management = (props) => {
  const { t } = useTranslation("common");

  // *****************************************************************
  // ****************** UseStates / UseRef *********************
  // *****************************************************************

  const [filtreStatus, setFiltreStatus] = useState(null);
  const [filtreMotsCles, setFiltreMotsCles] = useState("");
  const [filtreDate, setFiltreDate] = useState(null);
  const [filtreCompany, setFiltreCompany] = useState(null);
  const [filtreDiffuseur, setFiltreDiffuseur] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [filterCompanyList, setFilterCompanyList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [filterDiffuseurList, setFilterDiffuseurList] = useState([]);
  const [massActions, setMassActions] = useState(false);
  const [resetStatus, setResetStatus] = useState(false);

  // *****************************************************************
  // ****************** UseEffect *********************
  // *****************************************************************

  // Hook qui se déclenche au changement de statut d'un des filtres
  useEffect(() => {
    if (!filtreDate || (filtreDate[0] && filtreDate[1])) {
      handleFilter();
    }
  }, [filtreStatus, filtreDate, filtreCompany, filtreDiffuseur, resetStatus]);

  const setFilters = (url) => {
    url.searchParams.set(
        "itemsPerPage",
        props.itemsPerPage ? props.itemsPerPage : 20
    );

    if (props.auth.isAdmin) {
      if (props.currentTransmitter[0] === "all") {
        url.searchParams.delete("transmitter[]");
      } else {
        props.currentTransmitter.forEach((transmitter) => {
          url.searchParams.append("transmitter[]", transmitter);
        });
      }
    } else {
      url.searchParams.append(
          props.actualPage === "offre" ? "createdByUser[]" : "createdBy[]",
          props.auth.userConnected.id
      );
    }
    if (filtreMotsCles != "") url.searchParams.set("keyword", filtreMotsCles);
    if (filtreStatus) url.searchParams.set("state", filtreStatus.id);
    if (filtreCompany) url.searchParams.set("entreprise", filtreCompany.id);
    if (filtreDiffuseur) url.searchParams.set("diffuseur", filtreDiffuseur.id);
    if (filtreDate && filtreDate[0])
      url.searchParams.set(
          props.actualPage === "événement"
              ? "startingAt[after]"
              : "modifiedAt[after]",
          formatDateDatabase(filtreDate[0])
      );
    if (filtreDate && filtreDate[1])
      url.searchParams.set(
          props.actualPage === "événement"
              ? "endingAt[before]"
              : "modifiedAt[before]",
          formatDateDatabase(filtreDate[1])
      );
    return url;
  };
  // Fonction globale de filtre
  const handleFilter = () => {
    let url = null;

    if (props.actualPage === "offre") {
      url = setFilters(
          props.currentTransmitter[0] === "Recruteur"
              ? new URL(`${process.env.REACT_APP_BASE_URL_API}/offers/recruiter`)
              : new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`)
      );
      url.searchParams.set("order[modifiedAt]", "desc");
    } else if (props.actualPage === "événement") {
      url = setFilters(
          props.currentTransmitter[0] === "Recruteur"
              ? new URL(`${process.env.REACT_APP_BASE_URL_API}/events/recruiter`)
              : new URL(`${process.env.REACT_APP_BASE_URL_API}/events`)
      );
      url.searchParams.set("order[startingAt]", "asc");
      url.searchParams.set("endingAt[after]", formatDateDatabase(new Date()));
    } else if (props.actualPage === "actu") {
      url = setFilters(
          props.currentTransmitter[0] === "Recruteur"
              ? new URL(`${process.env.REACT_APP_BASE_URL_API}/news/recruiter`)
              : new URL(`${process.env.REACT_APP_BASE_URL_API}/news`)
      );
      url.searchParams.set("order[modifiedAt]", "desc");
    }

    url.searchParams.set("university[]", props.auth.universityConnected.id);

    props.setUrl(url);
  };

  return (
      <div className="management_new_event_offer_filtres">
        <div className="management_new_event_offer_filtres__top">
          {/* Filtre par mots clés */}
          <div>
            <HiSearch
                className="searchBar_groupe_finder_icon"
                onClick={(e) => {
                  e.preventDefault();
                  handleFilter();
                }}
            />
            <InputText
                placeholder={
                  props.actualPage === "événement"
                      ? t("evenementsHorsConnexion.placeholder_research")
                      : props.actualPage === "offre"
                          ? t("offresHorsConnexion.placeholder_research")
                          : t("actusHorsConnexion.placeholder_research")
                }
                value={filtreMotsCles}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleFilter();
                  }
                }}
                onChange={(e) => {
                  setFiltreMotsCles(e.target.value);
                }}
                className="membership_input_text"
            />
          </div>
          {/* Filtre par statut */}
          <Dropdown
              value={filtreStatus}
              optionLabel="name"
              className="membership_input_search"
              placeholder={t("actusApresConnexion.filtreStatut")}
              showClear
              options={props.states}
              onChange={(e) => {
                if (props.actualPage === "offre") {
                  if (e.target.value?.statusLabel === "En Attente")
                    setMassActions(true);
                  else {
                    setMassActions(false);
                    props.setItemsPerPage(20);
                  }
                }

                setFiltreStatus(e.target.value);
              }}
          />
          {/* Filtre par date */}
          <div
              className={
                !filtreDate || (filtreDate[0] && filtreDate[1])
                    ? "management_new_event_offer_filtres__top__date"
                    : "management_new_event_offer_filtres__top__date warning"
              }
          >
            <ReactDatePicker
                placeholderText={t("actusApresConnexion.filtreDate")}
                selected={filtreDate && filtreDate[0]}
                onChange={(e) => {
                  setFiltreDate(e);
                }}
                dateFormat="dd/MM/yyyy"
                startDate={filtreDate && filtreDate[0]}
                endDate={filtreDate && filtreDate[1] && filtreDate[1]}
                selectsRange
            />
            {filtreDate !== null && (
                <CgClose
                    onClick={() => {
                      setFiltreDate(null);
                    }}
                ></CgClose>
            )}
          </div>
          {/* Filtre par entreprise si le isActive du bouton entreprise est true */}
          {props.auth.isConnected &&
              props.auth.isAdmin &&
              props.btnEntreprise.isActive && (
                  <Dropdown
                      value={filtreCompany}
                      className="membership_input_search"
                      placeholder="Filtrer par entreprise"
                      showClear
                      options={filterCompanyList}
                      onChange={(e) => {
                        setFiltreCompany(e.target.value);
                      }}
                  />
              )}
          {/* Filtre par diffuseur si le isActive du bouton diffuseur est true */}
          {props.auth.isConnected &&
              props.auth.isAdmin &&
              props.btnDiffuseur?.isActive && (
                  <Dropdown
                      value={filtreDiffuseur}
                      className="membership_input_search"
                      placeholder="Filtrer par diffuseur"
                      showClear
                      options={filterDiffuseurList}
                      onChange={(e) => {
                        setFiltreDiffuseur(e.target.value);
                      }}
                  />
              )}
          {/* refresh filters */}
          {(filtreMotsCles ||
              filtreStatus ||
              filtreCompany ||
              filtreDiffuseur ||
              (filtreDate && filtreDate[1])) && (
              <li className="management_new_event_offer_filtres__top__refresh">
                <i
                    className="pi pi-refresh"
                    style={{ fontSize: "1.5rem", fontWeight: "600" }}
                    onClick={() => {
                      setFiltreStatus(null);
                      setFiltreDiffuseur(null);
                      setFiltreCompany(null);
                      setFiltreDate(null);
                      setFiltreMotsCles("");
                      props.setItemsPerPage(20);
                      setMassActions(false);
                      setResetStatus(!resetStatus);
                    }}
                />
              </li>
          )}
          {props.actualPage &&
              props.actualPage === "événement" &&
              (props.auth.isAlumni || props.auth.isPersonnel) && (
                  <div className="management_new_event_offer_filtres__top__createBtn">
                    <Link to={{ pathname: `/evenements` }}>
                      <BtnBlancLeft
                          btnTexte={t("eventApresConnexion.submenuProposerAlumni")}
                          btnAction={() => {
                            props.handleMenu({
                              activeItemEvenement: props.items.itemsEvenement.findIndex(
                                  (v) => v.label == "Proposer un événement"
                              ),
                            });
                          }}
                      ></BtnBlancLeft>
                    </Link>
                  </div>
              )}
          {props.actualPage &&
              props.actualPage === "événement" &&
              props.auth.isAdmin && (
                  <div className="management_new_event_offer_filtres__top__createBtn">
                    <Link to={{ pathname: `/evenements` }}>
                      <BtnBlancLeft
                          btnTexte={t("eventApresConnexion.submenuCreateAdmin")}
                          btnAction={() => {
                            props.handleMenu({
                              activeItemEvenementAdmin:
                                  props.items.itemsEvenementAdmin.findIndex(
                                      (v) => v.label == "Créer un événement"
                                  ),
                            });
                          }}
                      ></BtnBlancLeft>
                    </Link>
                  </div>
              )}
          {props.actualPage &&
              props.actualPage === "actu" &&
              (props.auth.isAlumni || props.auth.isPersonnel) && (
                  <div className="management_new_event_offer_filtres__top__createBtn">
                    <BtnBlancLeft
                        btnTexte={t("actusApresConnexion.submenuCreateAlumni")}
                        btnAction={() =>
                            props.handleMenu({
                              activeItemActu: props.items.itemsActu.findIndex(
                                  (v) => v.label == "Proposer une actu"
                              ),
                            })
                        }
                    >
                      <FaPen />
                    </BtnBlancLeft>
                  </div>
              )}
          {props.actualPage &&
              props.actualPage === "actu" &&
              props.auth.isAdmin && (
                  <div className="management_new_event_offer_filtres__top__createBtn">
                    <BtnBlancLeft
                        btnTexte={t("actusApresConnexion.submenuCreateAdmin")}
                        btnAction={() =>
                            props.handleMenu({
                              activeItemActuAdmin: props.items.itemsActuAdmin.findIndex(
                                  (v) => v.label == "Créer une actu/conseil"
                              ),
                            })
                        }
                    >
                      <FaPen />
                    </BtnBlancLeft>
                  </div>
              )}
        </div>
        {massActions && props.auth.isAdmin && (
            <MassActions
                itemsPerPage={props.itemsPerPage}
                setItemsPerPage={props.setItemsPerPage}
                url={props.url}
                setUrl={props.setUrl}
            ></MassActions>
        )}
      </div>
  );
};

Management.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  offers: PropTypes.object,

  handleMenu: PropTypes.func,
  updateFunction: PropTypes.func,

  states: PropTypes.array,
  btnEntreprise: PropTypes.array,
  btnDiffuseur: PropTypes.array,
  currentTransmitter: PropTypes.array,
  actualPage: PropTypes.string,
  itemsPerPage: PropTypes.number,
  setItemsPerPage: PropTypes.func,
  url: PropTypes.string,
  setUrl: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  offers: state.offers,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Management);
